import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import getCartDeliveryTimeExpected from '@core/reducers/cart/selectors/getCartDeliveryTimeExpected';
import getHasCart from '@core/reducers/cart/selectors/getHasCart';
import getCartMinDeliveryAmount from '@core/reducers/cart/selectors/getCartMinDeliveryAmount';
import getCartShippingAmount from '@core/reducers/cart/selectors/getCartShippingAmount';
import getUseLiveOrderTracking from '@core/reducers/shop/selectors/getUseLiveOrderTracking';
import { getDeliveryTimeFromDTS } from '@funWithFlags/selectors';
import getCartPlusInfo from '@core/reducers/cart/selectors/getCartPlusInfo';
import DeliveryInfo from './DeliveryInfo';

const mapStateToProps = createStructuredSelector({
  deliveryTime: getCartDeliveryTimeExpected,
  shippingAmount: getCartShippingAmount,
  minDeliveryAmount: getCartMinDeliveryAmount,
  hasCart: getHasCart,
  plusSettings: getCartPlusInfo,
  isDeliveryTimeFromDTSEnabled: getDeliveryTimeFromDTS,
  useLiveOrderTracking: getUseLiveOrderTracking,
});

export default connect(mapStateToProps, null)(DeliveryInfo);
